import React, { useState, useEffect } from "react";
import bootstrap from "bootstrap/dist/js/bootstrap";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { api } from "../../../utils/Api";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";

const animatedComponents = makeAnimated();

let myModal = {};

export default function ModalViewService(props: any) {
  const [close_data, SetCloseData] = useState({
    action: "close",
  });
  const [id_value, SerIdValue] = useState(useParams());
  const [service_data, SetServiceData] = useState({});
  const [read_only, SetReadOnly] = useState(true);
  const [selected_value, SetSelectedValue] = useState("Service");
  const [save_data, SetSaveData] = useState({});

  useEffect(() => {
    console.log("ModalViewService On mount :", props);
    let myModal1 = document.getElementById("ViewServiceModal");
    myModal1.addEventListener("hidden.bs.modal", function (event) {
      SetSaveData({});
      SetServiceData({});
      props.close(close_data);
    });
  }, []);

  useEffect(() => {
    if (props.open) {
      console.log("On Open modal :", props);
      myModal = new bootstrap.Modal(
        document.getElementById("ViewServiceModal"),
        {}
      );
      myModal.show();
      if (props.type != "view") {
        SetReadOnly(false);
      } else {
        SetReadOnly(true);
      }
      get_service();
    }
  }, [props.open]);

  async function get_service() {
    SetServiceData(props.data);
    let service_value = props.data;
    if (service_value.hasOwnProperty("price")) {
      SetSelectedValue("Service");
      SetSaveData((prevValue) => {
        prevValue.id = service_value.id;
        prevValue.price = service_value.price;
        return { ...prevValue };
      });
    } else {
      let task_value = [];
      service_value.task.map((t_ele: any, t_index: any) => {
        let task_obj = {
          id: t_ele.id,
          name: t_ele.name,
        };
        if (t_ele.hasOwnProperty("price")) {
          SetSelectedValue("Task");
          task_obj.price = t_ele.price;
        } else {
          task_obj.price = "";
        }
        task_value.push(task_obj);
      });
      SetSaveData((prevValue) => {
        prevValue.id = service_value.id;
        prevValue.price = "";
        prevValue.task = task_value;
        return { ...prevValue };
      });
    }
  }

  async function update_price() {
    console.log("update_price :", save_data);
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
      },
      post: {
        services: [save_data],
      },
    };
    let data = await api("/outlet/update_services_tasks_price", pass_data);
    console.log("update_services_tasks_price response :", data.response);
    if (data.response.hasOwnProperty("services")) {
      SetCloseData((prevValue) => {
        prevValue.action = "save";
        prevValue.services = data.response.services;
        return { ...prevValue };
      });
      myModal.hide();
    }
  }

  return (
    <div
      className="modal fade"
      id="ViewServiceModal"
      tabIndex={-1}
      aria-labelledby="ModalLabel"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="  modal-title" id="ModalLabel">
              {props.type == "edit" ? "Edit " : "View "}Pricing
            </h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            ></button>
          </div>

          <div className="modal-body scroll-height">
            <h6 className="fs-6 mb-2">{service_data.name}</h6>
            <div className="row">
              <div className="col-md-4">
                <div className="radio p-3">
                  <label>
                    <input
                      type="radio"
                      value="Service"
                      className="me-2"
                      checked={selected_value === "Service"}
                      onChange={() => {
                        SetSelectedValue("Service");
                        SetSaveData((prevValue) => {
                          prevValue.task = [];
                          return { ...prevValue };
                        });
                      }}
                      disabled={read_only}
                    />
                    Service
                  </label>
                </div>
                <div className="radio p-3">
                  <label>
                    <input
                      type="radio"
                      className="me-2"
                      value="Task"
                      checked={selected_value === "Task"}
                      onChange={() => {
                        SetSelectedValue("Task");
                        let task_value = [];
                        service_data.task.map((t_ele: any, t_index: any) => {
                          let task_obj = {
                            id: t_ele.id,
                            name: t_ele.name,
                          };
                          if (t_ele.hasOwnProperty("price")) {
                            SetSelectedValue("Task");
                            task_obj.price = t_ele.price;
                          } else {
                            task_obj.price = "";
                          }
                          task_value.push(task_obj);
                        });
                        SetSaveData((prevValue) => {
                          prevValue.id = service_data.id;
                          prevValue.price = "";
                          prevValue.task = task_value;
                          return { ...prevValue };
                        });
                      }}
                      disabled={read_only}
                    />
                    Task
                  </label>
                </div>
              </div>
              <div className="col-md-8">
                {selected_value == "Service" ? (
                  <div className="px-3 ">
                    <label className="form-label pe-2">Price</label>
                    <input
                      type="number"
                      className="form-control"
                      required
                      readOnly={read_only}
                      value={
                        save_data.hasOwnProperty("price")
                          ? save_data.price
                          : null
                      }
                      onChange={(e) => {
                        SetSaveData((prevValue) => {
                          prevValue.price = e.target.value;
                          return { ...prevValue };
                        });
                      }}
                    />
                  </div>
                ) : (
                  <div className="px-3">
                    {Object.keys(save_data).length > 0 &&
                      save_data.task.map((t_ele: any, t_index: any) => (
                        <div>
                          <label className="form-label">
                            {t_ele.name} Price
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            required
                            readOnly={read_only}
                            value={
                              t_ele.hasOwnProperty("price") ? t_ele.price : null
                            }
                            onChange={(e) => {
                              SetSaveData((prevValue) => {
                                prevValue.task[t_index].price = e.target.value;
                                if (!e.target.value) {
                                  delete prevValue.task[t_index].price;
                                }
                                return { ...prevValue };
                              });
                            }}
                          />
                        </div>
                      ))}
                  </div>
                  )}
              </div>
             
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light-outline"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            >
              Close
            </button>
            {props.type == "edit" ? (
              <button
                type="button"
                className="btn btn-light-outline"
                onClick={() => {
                  if (selected_value == "Service") {
                    if (save_data.price != "") {
                      update_price();
                    } else {
                      toast.error("Price For Service Not Available");
                    }
                  } else {
                    let task_value = save_data.task.some((e) =>
                      e.hasOwnProperty("price")
                    );
                    if (task_value) {
                      update_price();
                    } else {
                      toast.error("Price For Task Not Available");
                    }
                  }
                }}
              >
                Save
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
